export class OrderCategory {
    public Organisationid: number;
    public CategoryId: number;
    public CategoryName: string;
    public CategoryDescription: string;
    public CategoryImage: string;
}
